import { z } from "zod";
import { CompositionDto } from "./editor.ts";
import { AnimatedImageDto } from "./animated-image.ts";

export const VideoSort = z.enum(["lastUpdated", "dateCreated", "name"]);

export const GetVideosQuery = z.object({
  page: z.coerce.number().optional(),
  sort: VideoSort.optional().default("lastUpdated"),
});

export const SearchVideosQuery = z.object({
  search: z.string().trim().min(1),
});

export const DeleteVideoDto = z.object({
  deletedAt: z.string(),
});

export const RenameVideoDto = z.object({
  name: z.string().trim().min(1),
});

export const VideoDto = z.object({
  externalId: z.string(),
  updatedAt: z.string(),
  thumbnailUrl: z.string().optional(),
  name: z.string(),
});

export const CompositionForTimingsDto = CompositionDto.pick({
  fps: true,
  aspectRatio: true,
  mainSceneTimeline: true,
  startScene: true,
  endScene: true,
  elements: true,
});

export const AnimatedImageForTimingsDto = AnimatedImageDto.pick({
  durationMs: true,
});

export const PagedVideoItemDto = VideoDto.extend({
  compositionJson: CompositionForTimingsDto,
  animatedImages: z.record(z.string(), AnimatedImageForTimingsDto),
});

export const PagedVideoResponse = z.object({
  videos: z.array(PagedVideoItemDto),
  nextPage: z.number().optional(),
});

export type VideoDto = z.infer<typeof VideoDto>;
export type CompositionForTimingsDto = z.infer<typeof CompositionForTimingsDto>;
export type AnimatedImageForTimingsDto = z.infer<
  typeof AnimatedImageForTimingsDto
>;
export type PagedVideoItemDto = z.infer<typeof PagedVideoItemDto>;
export type GetVideosQuery = z.infer<typeof GetVideosQuery>;
export type VideoSort = z.infer<typeof VideoSort>;
export type SearchVideosQuery = z.infer<typeof SearchVideosQuery>;
export type DeleteVideoDto = z.infer<typeof DeleteVideoDto>;
export type RenameVideoDto = z.infer<typeof RenameVideoDto>;
export type PagedVideoResponse = z.infer<typeof PagedVideoResponse>;
